/**
 * React Select Input Wrapper
 * Styles overriding using this documentation guide https://react-select.com/styles
 */

import React from "react"
import { Wrapper, LabelContainer, Label, ControlWrapper } from "./styles"
import "./custom-flag-select.css"
import ReactFlagsSelect from "react-flags-select"
import { getQueryParameters } from "utils/utils"
import { getFormConfigurationFromOrganization } from "utils/configUtils"
import { generateNewClientDomainPath } from "utils/clientUtils"
import { SizeContext } from "../../App"
import Translate from "components/Translate/container"

class CountrySelectField extends React.Component {
  static contextType = SizeContext

  updateCountry = countryCode => {
    const clientConfig = getFormConfigurationFromOrganization(
      this.props.organization
    )
    const colocatedCountries = clientConfig.colocatedCountries
    const countryMap = colocatedCountries?.find(
      country => country.id === countryCode
    )
    const params = new URLSearchParams(window.location.search)
    const paramsMap = Object.fromEntries(params.entries())
    paramsMap.country = countryMap.id

    const path =
      generateNewClientDomainPath(countryMap.clientDomain) +
      `${window.location.pathname}?${new URLSearchParams(paramsMap).toString()}`
    window.location.href = path
  }

  render() {
    const { organization, label, justifyContent, noMargin } = this.props
    const clientConfig = getFormConfigurationFromOrganization(organization)
    const colocatedCountries = clientConfig.colocatedCountries
    const query = getQueryParameters(window.location)

    const selectCountriesList = colocatedCountries?.map(country => country.id)

    const smallScreen = this.context === "sm"
    let noLablesForSmallScreens

    if (smallScreen) {
      noLablesForSmallScreens = selectCountriesList.reduce((acc, country) => {
        acc[country] = " " // Passing a blank space removes label and shows flag only.
        return acc
      }, {})
    }

    return (
      selectCountriesList?.length > 0 && (
        <Wrapper justifyContent={justifyContent}>
          <LabelContainer margin={label}>
            <Label>
              <Translate>{label}</Translate>
            </Label>
          </LabelContainer>
          <ControlWrapper noMargin={noMargin}>
            <ReactFlagsSelect
              className="custom-flag-select"
              placeholder={<Translate>Select</Translate>}
              id={`countrySelect`}
              countries={selectCountriesList}
              customLabels={smallScreen && noLablesForSmallScreens}
              onSelect={value => {
                this.updateCountry(value)
              }}
              selected={query.country}
              getOptionLabel={({ value }) => value}
            />
          </ControlWrapper>
        </Wrapper>
      )
    )
  }
}

export default CountrySelectField
